<section class="main-section-help-user-account">
  <div id="iposFAQs" class="main_section_headers" i18n="@@ipos-help.faq.title.faqs">FAQs</div>

  <div class="accordion" id="faqAcc">
    <!-- Section 1 -->
    <div id="faqCard" class="card" #errorReport>
      <div id="faqCardHeader" class="card-header" id="faqOne">
        <div id="faqCardHeaderContent" class="card-header-content d-flex">
          <div id="faqCardTitle" class="title" i18n="@@ipos-help.faq.title.submitting-error-report">SUBMITTING AN ERROR REPORT</div>
          <div id="faqCardSubmitReport" class="table_collapse_link collapsed " data-toggle="collapse" [attr.aria-expanded]="isSubmitErrorReport"
            aria-controls="collapseOne" id="submitErrorReportSection">
            <img (click)="showDescription('submitErrorReport')"
              class="accordion_arrow chevron_down_dark table_row_expanded" alt="toggle section"
              [ngClass]="isSubmitErrorReport?'transform-180':''" />
          </div>
        </div>
      </div>
      <div id="submitErrorReportSection" aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div"
        data-parent="#submitErrorReportSection" #collapse="ngbCollapse" [(ngbCollapse)]="!isSubmitErrorReport">
        <div id="faqCardBody" class="card-body">
          <div id="faqCardBodyContent" class="content">
            <span i18n="@@ipos-help.faq.how-to-collect-error-report-text"><strong>How do I collect an error report from IPOS/the PC?</strong></span>
            <p>
              <span i18n="@@ipos-help.faq.has-an-issue-that-cant-resolve-text">Have an issue that you can’t resolve in this guide? IPOS
              includes a built-in error reporting tool. (Available only on
              Windows* and Linux* operating systems). To access the error
              reporting tool, go to
              <span class="text-primary">C:\Program Files\Ipos\IposErrorReporting.exe</span>
              on the device.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.faq.tool-allow-to-save-text">This tool will allow you to save screenshots and enter a
              <strong>Name</strong>, <strong>Email ID</strong> and a <strong>Description</strong> related to your issue.
              It
              gathers all logs and error messages directly from the device
              and zips them together for you.</span>
            </p>

            <!-- Preview image -->
            <img class="mb-3 help_faqs_one" alt="steps to get error report form PC" />
            <div id="faqSendReportText">
              <span i18n="@@ipos-help.faq.whom-to-send-report-text"><strong>Who do I send the error report to?</strong></span>
            </div>
            <div id="faqConnectedText" i18n="@@ipos-help.faq.if-your-device-connected-text">If your device is connected to the internet, you have the
              ability to submit the report directly from the app. Without
              an internet connection, please contact a local IPOS representive.</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 2 -->
    <div id="specsCard" class="card" #specs>
      <div id="specsCardHeader" class="card-header" id="faqTwo">
        <div id="specsCardHeaderContent" class="card-header-content d-flex">
          <div id="specsCardHeaderTitle" class="title" i18n="@@ipos-help.faq.title.specs">SPECS</div>
          <div id="specsCardHeaderErrReport" class="table_collapse_link collapsed " data-toggle="collapse" [attr.aria-expanded]="isSubmitErrorReport"
            aria-controls="collapseOne" id="specs">
            <img (click)="showDescription('specs')" class="accordion_arrow chevron_down_dark table_row_expanded"
              alt="toggle section" [ngClass]="isSpecs?'transform-180':''" />
          </div>
        </div>
      </div>
      <div id="specs" aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div" data-parent="#specs"
        #collapse="ngbCollapse" [(ngbCollapse)]="!isSpecs">
        <div class="card-body" id="specsCardBody">
          <div class="content" id="specsCardContent">
            <span i18n="@@ipos-help.faq.specs-what-are-the-specs-text"><strong>What are the specs for promotion content?</strong></span>
            <div>
              <span i18n="@@ipos-help.faq.specs-images-text">Images</span>:
              <ul>
                <li><span i18n="@@ipos-help.faq.specs-content-areas-text">Content areas can be up to <strong>3 pages</strong> with 1 image or video per page.</span>
                </li>
                <li><span i18n="@@ipos-help.faq.specs-images-must-be-jpeg-or-png-text">Images must be JPEG or PNG format. No maximum dimension, as images will be automatically scaled
                    to fit the area.</span></li>
                <li><span i18n="@@ipos-help.faq.specs-recommended-highest-quality-images-text">Recommend highest quality images, which are less than <strong>5 MB</strong> in size.</span>
                </li>
              </ul>
            </div>
            <div id="videosCardContent">
              <span i18n="@@ipos-help.faq.specs-videos-text">Videos</span>:
              <ul>
                <li><span i18n="@@ipos-help.faq.specs-videos-must-be-mp4-text">Videos must be in MP4 format and less than <strong>60 seconds</strong> in length.</span></li>
                <li><span i18n="@@ipos-help.faq.specs-videos-allowed-size-text">Maximum allowed file size is <strong>10 MB</strong> (smaller videos are better if including
                    multiple videos in 1 package).</span></li>
                <li><span i18n="@@ipos-help.faq.specs-videos-aspect-ratio-text">Recommended aspect ratio is <strong>16:9</strong>.</span></li>
              </ul>
            </div>

            <div class="mt-3" id="logoText">
              <span i18n="@@ipos-help.faq.specs-what-specs-for-logo-text"><strong>What are the specs for my logo to best display?</strong></span>
            </div>
            <ul>
              <li i18n="@@ipos-help.faq.specs-logo-must-be-png-jpg-text">Logos must be PNG, JPG, or GIF format.</li>
              <li i18n="@@ipos-help.faq.specs-logo-max-size-text">Maximum allowed size is <strong>10 MB</strong>.</li>
              <li i18n="@@ipos-help.faq.specs-logo-no-dimensions-text">No specified dimensions, as images will be automatically scaled to fit the area. Images in landscape orientation work best in the space provided.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 3 -->
    <div class="card" #gamedemo id="gameDemoCard">
      <div class="card-header" id="faqThree">
        <div class="card-header-content d-flex" id="gameDemoCardHeaderContent">
          <div class="title" id="gameDemoCardHeaderTitle" i18n="@@ipos-help.faq.title.game-demo">GAME DEMO</div>
          <div class="table_collapse_link collapsed " data-toggle="collapse" [attr.aria-expanded]="isGameDemo"
            aria-controls="collapseOne" id="gameDemo">
            <img (click)="showDescription('gameDemo')" class="accordion_arrow chevron_down_dark table_row_expanded"
              alt="toggle section" [ngClass]="isGameDemo?'transform-180':''" />
          </div>
        </div>
      </div>
      <div id="gameDemo" aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div"
        data-parent="#gameDemo" #collapse="ngbCollapse" [(ngbCollapse)]="!isGameDemo">
        <div id="faqGameRegionText" class="card-body">
          <div id="faqGameRegionContent" class="content">
            <span i18n="@@ipos-help.faq.game-demo-what-if-my-region-wont-allow-text"><strong>What do I do if my region won’t allow the game demo to be
              displayed on IPOS?</strong></span>
            <p>
              <span i18n="@@ipos-help.faq.game-demo-what-exclude-game-demo-text">If your region does not allow the game demo to be displayed,
              you can simply exclude it by selecting the
              <strong>Exclude Game Demo</strong> option in the
              <strong>Profile Info</strong> section while creating a
              custom installation profile.</span>
            </p>
            <div id="faqGamePckgText" class="mt-2">
              <span i18n="@@ipos-help.faq.game-demo-note-all-standard-packages-text"><strong>Note:</strong> All Standard packages will include the game demo, but it can be switched off
                in the On-Device Administration tool.</span>
            </div>
            <!-- Preview image -->
            <img class="help_faqs_two" alt="exclude game demo for gaming ipos" />
          </div>
        </div>
      </div>
    </div>

    <!-- Section 4 -->
    <div class="card" #windows id="windowsCard">
      <div class="card-header" id="faqFour">
        <div class="card-header-content d-flex" id="windowsCardHeaderContent">
          <div class="title" id="windowsCardTitle" i18n="@@ipos-help.faq.title.win-10s">WINDOWS* 10 S</div>
          <div class="table_collapse_link collapsed " id="windowsCard10s" data-toggle="collapse" [attr.aria-expanded]="isWindows10s"
            aria-controls="collapseOne" id="win10s">
            <img (click)="showDescription('win10s')" class="accordion_arrow chevron_down_dark table_row_expanded"
              alt="toggle section" [ngClass]="isWindows10s?'transform-180':''" />
          </div>
        </div>
      </div>
      <div id="win10s" aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div" data-parent="#win10s"
        #collapse="ngbCollapse" [(ngbCollapse)]="!isWindows10s">
        <div id="win10sCardBody" class="card-body">
          <div class="content" id="win10sCardContent">
            <span i18n="@@ipos-help.faq.win-10s-will-ipos-work-text"><strong>Will IPOS work on Windows* 10 in S mode devices?</strong></span>
            <p>
              <span i18n="@@ipos-help.faq.win-10s-yes-ipos-will-work-text">Yes, IPOS will work on Windows* 10 S mode devices. You have to generate a separate package for UWP and download the Windows* 10 for S mode app from the Microsoft* Store to install IPOS on Windows* 10 S mode.</span>
            </p>
            <!-- Preview image -->
            <img class="help_faqs_three" alt="ipos works on win10s!" />
          </div>
        </div>
      </div>
    </div>

    <!-- Section 6 -->
    <div class="card" #devices id="devicesCard">
      <div class="card-header" id="faqFive">
        <div class="card-header-content d-flex" id="devicesCardHeaderContent">
          <div class="title" id="devicesCardTitle" i18n="@@ipos-help.faq.title.devices">DEVICES</div>
          <div class="table_collapse_link collapsed " id="devicesCardTitle" data-toggle="collapse" [attr.aria-expanded]="isDevices"
            aria-controls="collapseOne" id="devices">
            <img (click)="showDescription('devices')" class="accordion_arrow chevron_down_dark table_row_expanded"
              alt="toggle section" [ngClass]="isDevices?'transform-180':''" />
          </div>
        </div>
      </div>
      <div id="devices" aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div" data-parent="#devices"
        #collapse="ngbCollapse" [(ngbCollapse)]="!isDevices">
        <div id="devicesCardBody" class="card-body">
          <div class="content" id="devicesCardContent">
            <span i18n="@@ipos-help.faq.devices-best-use-device-lookup-table"><strong>How do I best use the Device Lookup Table?</strong></span>
            <p>
              <span i18n="@@ipos-help.faq.devices-to-manage-number-text">To manage a large number of display devices, it may be
              desirable to streamline the installation process. While
              installing IPOS on a device, you’ll be prompted to select
              the <strong>SKU/Device ID</strong> that matches with the
              device. It will automatically populate price, battery life,
              and Segment fields on the device.</span>
            </p>
            <ul>
              <li i18n="@@ipos-help.faq.upload-sku-lookup-text">The <strong>Upload SKU Lookup Table</strong> function allows you to
                import a file of devices’ price, battery life, and
                Segment.</li>
              <li><span i18n="@@ipos-help.faq.contain-one-record-per-device">It should contain one record per device. There are four
                pieces of information that can be included in each record
                in the lookup table. All elements are optional, though at
                least one element must be entered for each record.</span>
                <ol style="list-style-type: upper-roman">
                  <li i18n="@@ipos-help.faq.devices-sku-code-text"><strong>SKU Code</strong>: This should be a unique up
                    to <strong>30-character</strong> code for each record. If left blank,
                    the admin console will assign an ID for you.</li>
                  <li i18n="@@ipos-help.faq.devices-primary-price-text"><strong>Primary Price</strong>: Please include the
                    currency symbol.</li>
                  <li i18n="@@ipos-help.faq.devices-secondary-price-text"><strong>Secondary Price</strong>: Please include the
                    currency symbol.</li>
                  <li i18n="@@ipos-help.faq.price-strikethrough-text"><strong>Price Strikethrough</strong>: Either true or false. If true, a diagonal line in the secondary price will appear.</li>
                  <li i18n="@@ipos-help.faq.battery-life-text"><strong>Battery Life</strong>: Enter the estimated
                    battery life as a range of hours.</li>
                  <li i18n="@@ipos-help.faq.devices-segmentid-text"><strong>Segment ID</strong>: Please include a required <strong>Segment ID</strong>.</li>
                  <li i18n="@@ipos-help.faq.devices-promotional-content-text"><strong>Promotional Content Group ID</strong>: Please include up to <strong>3</strong> required
                    <strong>Promotional Content Group IDs</strong>.</li>
                </ol>
              </li>
              <li i18n="@@ipos-help.faq.devices-csv-saved-text">It must be saved in comma-separated value (CSV) format, which can be created in many applications, including Microsoft* Excel* and Google* Sheets*.</li>
              <li i18n="@@ipos-help.faq.devices-download-csv-template-text">You can download a CSV template by clicking the
                <strong>Download Template</strong> button.</li>
              <li i18n="@@ipos-help.faq.devices-setting-up-sku-table-text">Setting up your <strong>SKU Lookup Table</strong> is
                simple. You can either enter the information in the file
                yourself or export it from an inventory system.</li>
            </ul>
            <!-- Preview image -->
            <img class="mb-3 help_faqs_four" alt="upload SKU lookup table" />
            <div i18n="@@ipos-help.faq.devices-how-to-know-if-device-connected-text"><strong>How do I know if the device is connected to the
                internet/IPOS Central to get updates?</strong></div>
            <p>
              <span i18n="@@ipos-help.faq.devices-confirm-below-ways-text">You can confirm a device’s connectivity in the following 2 ways:</span>
            </p>
            <ol>
              <li i18n="@@ipos-help.faq.devices-status-on-device-dashboard-text"><strong>Status on Devices dashboard: Recently Connected</strong>
                (preceded by a green color) status indicates that IPOS
                has established a connection with the device within the
                last <strong>60 minutes</strong>.</li>
              <!-- Preview image -->
              <img class="mb-3 help_faqs_five" alt="connection status in devices table" />
              <li>
                <span i18n="@@ipos-help.faq.devices-top-right-corner-text"><strong>Top right corner of IPOS</strong></span>
                <ul>
                  <li>
                    <span i18n="@@ipos-help.faq.devices-status-will-be-connected-text">Status will be <strong>Connected</strong> when the device is connected.</span>
                  </li>
                  <li>
                    <span i18n="@@ipos-help.faq.devices-status-on-device-dashboard-text">Status will be <strong>Disconnected</strong> when the device is not connected.</span>
                  </li>
                </ul>
                <div class="mt-2">
                  <span i18n="@@ipos-help.faq.devices-note-device-not-connected-text"><strong>Note</strong>: If the device is not connected, you may exit to desktop and check your
                    internet connectivity.</span>
                </div>
              </li>
              <!-- Preview image -->
              <img class="help_faqs_six" alt="connection status in tile ipos" />
            </ol>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 7 -->
    <div class="card" #password id="passwordCard">
      <div class="card-header" id="faqSeven">
        <div class="card-header-content d-flex" id="passwordCardHeaderContent">
          <div class="title" id="passwordCardTitle" i18n="@@ipos-help.faq.title.ipos-password">IPOS PASSWORD</div>
          <div id="passwordTable" class="table_collapse_link collapsed " data-toggle="collapse" [attr.aria-expanded]="isIposPassword"
            aria-controls="collapseOne" id="iposPassword">
            <img (click)="showDescription('iposPassword')" class="accordion_arrow chevron_down_dark table_row_expanded"
              alt="toggle section" [ngClass]="isIposPassword?'transform-180':''" />
          </div>
        </div>
      </div>
      <div id="iposPassword" aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div"
        data-parent="#iposPassword" #collapse="ngbCollapse" [(ngbCollapse)]="!isIposPassword">
        <div id="passwordCardBody" class="card-body">
          <div id="passwordCardContent" class="content">
            <span i18n="@@ipos-help.faq.ipos-password-what-is-ipos-password"><strong>What is the IPOS password?</strong></span>
            <p><span i18n="@@ipos-help.faq.ipos-password-please-contact-local-ipos-representative-text">Please contact a local IPOS representative.</span></p>
            <span i18n="@@ipos-help.faq.ipos-password-where-to-reset-password-text"><strong>Where do I go to reset my IPOS Central password?</strong></span>
            <div i18n="@@ipos-help.faq.ipos-password-please-follow-below-steps-text">Please follow the below steps to reset your password:</div>
            <ol>
              <li i18n="@@ipos-help.faq.ipos-password-click-my-account-menu-link-text">Click the <strong>My Account</strong> menu link.</li>
              <li i18n="@@ipos-help.faq.ipos-password-click-change-your-password-text">Click the <strong>Change Your IPOS Central Account Password</strong> hyperlink.</li>
              <li i18n="@@ipos-help.faq.ipos-password-you-will-be-navigated-text">You will be navigated to the
                <strong>Reset Password</strong> screen. Enter the
                <strong>New Password</strong> and
                <strong>Confirm Password</strong>.</li>
              <li i18n="@@ipos-help.faq.ipos-password-save-changes-text">Save the changes.</li>
            </ol>
            <!-- Preview image -->
            <img class="help_faqs_seven" alt="changing IPOS central password" />
          </div>
        </div>
      </div>
    </div>

    <!-- Section 8 -->
    <div class="card" id="profilesCard" #profiles>
      <div class="card-header" id="faqEight">
        <div class="card-header-content d-flex" id="profilesCardHeader">
          <div class="title" id="profilesCardTitle" i18n="@@ipos-help.faq.title.ms-profiles">MS PROFILES</div>
          <div id="profilesCardTable" class="table_collapse_link collapsed " data-toggle="collapse" [attr.aria-expanded]="isMsProfiles"
            aria-controls="collapseOne" id="MSProfiles">
            <img (click)="showDescription('MSProfiles')" class="accordion_arrow chevron_down_dark table_row_expanded"
              alt="toggle section" [ngClass]="isMsProfiles?'transform-180':''" />
          </div>
        </div>
      </div>
      <div id="MSProfiles" aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div"
        data-parent="#MSProfiles" #collapse="ngbCollapse" [(ngbCollapse)]="!isMsProfiles">
        <div class="card-body" id="profilesCardBody">
          <div class="content" id="profilesCardContent">
            <span i18n="@@ipos-help.faq.ms-profiles-what-does-it-mean"><strong>What does MS profiles mean?</strong></span>
            <p><span i18n="@@ipos-help.faq.ms-profiles-is-a-feature-in-ipos"><strong>MS Profiles</strong> is a feature in IPOS that you
              can select while creating a Custom IPOS Installation
              Profile. It creates a demo account user and includes content
              that allows for a better experience of the Windows* OS.</span></p>
            <p><span i18n="@@ipos-help.faq.ms-profiles-are-activated-text">If MS profiles are activated, customers can experience
              several areas of the PC in the sales area, as they can
              access Windows* and see available apps.</span></p>
            <!-- Preview image -->
            <img class="mb-3 help_faqs_eight" alt="using MS Profiles option" />
            <div id="profilesCardContentText" i18n="@@ipos-help.faq.ms-profiles-in-addition-to-content">In addition to the content, this profile function also
              includes some additional security functions:</div>
            <ul>
              <li i18n="@@ipos-help.faq.ms-profiles-standard-demo-user-account">A standard demo user account, for example, Darrin DeYoung etc., is created when the profiles
                are installed.</li>
              <li i18n="@@ipos-help.faq.ms-profiles-shoppers-cannot-use-account">Shoppers cannot use this account to change any system
                settings (administrator password required).</li>
              <li i18n="@@ipos-help.faq.ms-profiles-after-installing-ipos">After installing IPOS on the device, IPOS overwrites the existing system password with the IPOS Primary password. Refer to the definition of passwords in the Creating a Custom Installation Package help section under Settings.</li>
              <li><span i18n="@@ipos-help.faq.ms-profiles-another-shopper-starts-text">If another shopper starts IPOS, web activities, settings,
                photos, etc., are automatically deleted.</span>
                <ul style="list-style-type: circle">
                  <li i18n="@@ipos-help.faq.ms-profiles-example-shopper-text">Example: A shopper goes to the desktop, tries out the
                    PC camera, and takes a picture. The shopper leaves the
                    PC. IPOS starts automatically and deletes all photos,
                    web activities, files, etc., from the standard demo
                    user account.</li>
                  <li i18n="@@ipos-help.faq.ms-profiles-ipos-can-set-text">IPOS can be set so that it starts again when the
                    system is inactive (1 minute, 2 minutes, 5 minutes, 10
                    minutes).</li>
                </ul>
              </li>
              <li i18n="@@ipos-help.faq.ms-profiles-every-system-related-text">For every system-related action by a shopper, a warning
                message appears that requires the administrator password
                to be entered.</li>
              <li i18n="@@ipos-help.faq.ms-profiles-all-of-the-above-text">The above security measures/settings do not apply when <strong>MS Profiles</strong> is turned
                off.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 9 -->
    <div class="card" #intsall id="installCard">
      <div class="card-header" id="faqNine">
        <div class="card-header-content d-flex" id="installCardHeaderContent">
          <div class="title" id="installCardTitle" i18n="@@ipos-help.faq.title.ipos-install-uninstall">IPOS INSTALL/UNINSTALL</div>
          <div id="installCardTable" class="table_collapse_link collapsed " data-toggle="collapse"
            [attr.aria-expanded]="isIposInstallUninstall" aria-controls="collapseOne" id="unInstallIPOS">
            <img (click)="showDescription('unInstallIPOS')" class="accordion_arrow chevron_down_dark table_row_expanded"
              alt="toggle section" [ngClass]="isIposInstallUninstall?'transform-180':''" />
          </div>
        </div>
      </div>
      <div id="unInstallIPOS" aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div"
        data-parent="#unInstallIPOS" #collapse="ngbCollapse" [(ngbCollapse)]="!isIposInstallUninstall">
        <div class="card-body">
          <div class="content">
            <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.how-to-install-question-text"><strong>How do I install IPOS?</strong></span>
            <p>
              <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.you-can-install-body-text">You can install IPOS on your device by just performing a few
              simple steps. Please view
              <a class="btn-link" (click)="navigate()">Installation Process</a> for more information.</span>
            </p>
            <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.what-if-i-dont-have-question-text"><strong>What if I don’t have a USB while installing a package?</strong></span>
            <p>
              <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.if-you-dont-have-usb-body-text">If you don’t have a USB or any other portable storage drive
              to transfer the package, you can download the package
              directly from the IPOS Central website on the device using
              an internet connection. You can also share the package link.</span>
            </p>
            <!-- Preview image -->
            <img class="mb-3 help_faqs_nine" alt="install custom IPOS" />
            <div id="installCardUninstallText" i18n="@@ipos-help.faq.title.ipos-install-uninstall.how-do-i-install-directly-question-text"><strong>How do I install directly from IPOS Central/online?</strong></div>
            <div id="installCardProfilesText" i18n="@@ipos-help.faq.title.ipos-install-uninstall.you-can-navigate-profiles-body-text">You can navigate to the <strong>Profiles</strong> tab and
              view the existing profiles.</div>
            <ul>
              <li i18n="@@ipos-help.faq.title.ipos-install-uninstall.package-already-gen-body-text">If your package is already generated, you can simply click
                the <strong>Download</strong> link to download a package.</li>
              <li i18n="@@ipos-help.faq.title.ipos-install-uninstall.package-not-gen-body-text">If your package is not generated, click the
                <strong>Generate Package</strong> button to generate your
                package. It may take some time depending on the size of
                the package. After it is generated, you have the option to
                either download it or share the link of the package.</li>
            </ul>
            <p>
              <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.please-click-to-navigate-body-text">Please view <a class="btn-link" (click)="navigate()">Installation Process</a> for
                installation steps.</span>
            </p>
            <!-- Preview image -->
            <img class="mb-3 help_faqs_ten" alt="install IPOS from existing profiles" />
            <div id="profilesQuestionsText" i18n="@@ipos-help.faq.title.ipos-install-uninstall.how-ddo-i-uninstall-question-text"><strong>How do I uninstall an older version of IPOS?</strong></div>
            <p>
              <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.if-packageis-showing-body-text">If this package is showing <strong>20CY2 or older</strong>, follow the below steps:</span>
            </p>
            <ol class="list-style-lower-roman">
              <li>
                <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.navigate-to-laa-body-text">Navigate to the <strong>Local Administrator Account</strong> IPOS was installed from. (You must sign
                  out of all other accounts, including the
                  IPOS Demo Account to uninstall.)</span>
              </li>
              <li>
                <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.run-uninstall-ipos-body-text">Run the <strong>Uninstall IPOS</strong> shortcut located on the desktop of the Local Administrator
                  Account.</span>
              </li>
              <img class="ipos-help-uninstall-screen-one" alt="uninstall screen">
              <li>
                <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.alternate-step-body-text">Alternatively, you can uninstall IPOS from the On-Device Administration tool by clicking the
                  <strong>Uninstall IPOS</strong> button.</span>
              </li>
              <img class="ipos-help-uninstall-screen-two" alt="uninstall screen">
              <li>
                <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.enter-yes-to-prompts-body-text">Enter <strong>Yes</strong> to the prompts.</span>
              </li>
              <li>
                <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.then-enter-uninstall-password-body-text">Then enter the <strong>Uninstall Password</strong> when prompted. If your entered password is valid,
                  the system will remove IPOS from the
                  device, then restart.</span>
              </li>
              <li>
                <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.select-yes-to-restart-body-text">Select <strong>Yes</strong> to restart.</span>
              </li>
            </ol>
            <div id="profilesNewerBodyText" class="mt-2">
              <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.21cy1-and-newer-body-text">For packages <strong>21CY1 and newer,</strong> follow the below steps:</span>
              <ol class="list-style-lower-roman">
                <li>
                  <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.navigate-to-laa-body-text">Navigate to the <strong>Local Administrator Account</strong> IPOS was installed from. (You must
                    sign out of all other accounts, including the
                    IPOS Demo Account to uninstall).</span>
                </li>
                <li>
                  <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.uninstall-from-oda-tool-body-text">You can uninstall IPOS from the On-Device Administration tool by clicking the <strong>Uninstall
                      IPOS</strong> button.</span>
                </li>
                <li>
                  <span i18n="@@ipos-help.faq.title.ipos-install-uninstall.enter-uninstall-password-prompted-text">Enter the <strong>Uninstall Password</strong> when prompted. If your entered password is valid,
                    the system will remove IPOS from
                    the device then restart.</span>
                </li>
              </ol>
            </div>

            <!-- Preview image -->
            <img class="mb-3 help_faqs_eleven" alt="uninstall IPOS" />

            <div class="mt-2"><span i18n="@@ipos-help.faq.title.how-to-reset-device"><strong>How to reset the device if the IPOS removal fails?</strong></span></div>
            <ol class="mt-2">
              <li i18n="@@ipos-help.faq.device-restart-select-troubleshoot">When the device restarts (by holding down the Shift key and restarting the PC), select <strong>Troubleshoot</strong> from the available options.</li>
              <li i18n="@@ipos-help.faq.from-troubleshoot-menu">From the Troubleshoot menu, select <strong>Reset this PC</strong> (this will let you choose to keep or remove your personal files, and then reinstalls Windows).</li>
              <li i18n="@@ipos-help.faq.after-select-remove-everything">After that, select <strong>Remove everything</strong> (all your personal files, apps, and settings will be removed).</li>
              <li i18n="@@ipos-help.faq.select-local-reinstall">Then select <strong>Local reinstall</strong> (Cloud downloads can take days to finish, so local reinstallation should be preferred).</li>
              <li>Next, select <strong>No</strong>.</li>
              <li i18n="@@ipos-help.faq.after-that-choose-fully-clean">After that, choose <strong>Fully clean the drive</strong>.</li>
              <li i18n="@@ipos-help.faq.finally-make-sure-pc-plugged">Finally, make sure the PC is plugged in and select <strong>Reset</strong> to start the reset process</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <!-- Section- 10 -->
    <div class="card" #tileUpgrade id="upgardeCard">
      <div class="card-header" id="faqTen">
        <div class="card-header-content d-flex">
          <div class="title" i18n="@@ipos-help.faq.title.ipos-upgrade-tile">UPGRADE TILE IPOS</div>
          <div class="table_collapse_link collapsed " data-toggle="collapse"
            [attr.aria-expanded]="isIposUpgrade" aria-controls="collapseOne" id="upgradeIPOS">
            <img (click)="showDescription('upgradeIPOS')" class="accordion_arrow chevron_down_dark table_row_expanded"
              alt="toggle section" [ngClass]="isIposUpgrade?'transform-180':''" />
          </div>
        </div>
      </div>
      <div aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div" data-parent="#upgradeIPOS" #collapse="ngbCollapse" [(ngbCollapse)]="!isIposUpgrade">
        <div class="card-body">
          <div class="content">
            <div><span i18n="@@ipos-help.faq.to-upgrade-ipos-user">To upgrade IPOS, the user does not need to uninstall IPOS on a device with IPOS already running on it.</span></div>
            <div><span i18n="@@ipos-help.faq.user-upgrade-without-unin-oldpkg">Here, the User will manually carry the package to the device and will upgrade the device without uninstalling the older package.</span></div>
            <div><span i18n="@@ipos-help.faq.ipos-running-instal-newpkg">If IPOS is running on a Windows Device and when it installs a new IPOS package on admin account, then proceed with the following steps.</span></div>
              <ul class="mt-2">
                <li i18n="@@ipos-help.faq.proceed-with-upgrade">Proceed with upgrade → If the retailer ID from the new package is same as that of the old package OR if the user ID (for unconnected scenarios) from the new package is same as that of the old package.</li>
                <li i18n="@@ipos-help.faq.ipos-version-pkg">The IPOS Version of the package that is being installed should be greater than or equal to the IPOS version that is already installed on the device. Otherwise an error message will be displayed.</li>
                <img class="display-error-msg-faq" alt="display error message">  
              </ul>
              <div><span i18n="@@ipos-help.faq.when-user-tries-install"><strong>When a user tries to install the package, then proceed with the following step.</strong></span></div>
              <ul>
                <li i18n="@@ipos-help.faq.ipos-automatically-start-upgrade">IPOS should automatically start upgrading. The upgrade should start behind the scenes and the user will be prompted with the installation screen basis below.</li>
              </ul>
              <ol>
                <li i18n="@@ipos-help.faq.option-select-language">Option to select the language → Skip this step if the language included in the package is same as that of the current selected language.</li>
                <li i18n="@@ipos-help.faq.option-select-license-agreement">Option to accept the license agreement → Skip this step if there haven't been any changes in the license agreement.</li>
                <li i18n="@@ipos-help.faq.option-select-store">Option to select store.</li>
                <ol class="list-style-lower-roman">
                  <li i18n="@@ipos-help.faq.prepopulate-store-from-oldpkg">For connected users - Prepopulate the store from the old package with an option to change the prepopulated store details</li>
                  <li i18n="@@ipos-help.faq.store-name-updated-store-selection">If a store name has been updated, allow users to do the store selection.</li>
                  <li i18n="@@ipos-help.faq.for-unconnected-user-skip-step">For unconnected users - Skip this step</li>
                </ol>
                <li i18n="@@ipos-help.faq.option-select-device-type">Option to select the device type → Prepopulate the device type selection from the previous selection.</li>
                <li i18n="@@ipos-help.faq.option-enter-sku-details">Option to enter SKU details.</li>
                <ol class="list-lower-roman">
                  <li i18n="@@ipos-help.faq.sku-csv-include-new-pkg-prepopulate-sku">If a SKU CSV is included in the new package and it contains the SKU that is selected on the device → prepopulate the SKU</li>
                  <li i18n="@@ipos-help.faq.no-sku-csv-in-new-pkg">If no SKU CSV is included in the new package → prepopulate the installation screen “Manually enter SKU details” (Price, Battery, Segment, etc.) from the old package.</li>
                </ol>
                <li i18n="@@ipos-help.faq.oda-panel-new-pkg-installed">The ODA panel of the new package installed will have the content merged from all the content groups and settings values from the ODA panel of the old package.</li>
                <div i18n="@@ipos-help.partner-portal.page-cg-note-text"><strong>Note:</strong></div>
                <div i18n="@@ipos-help.faq.device-id-remain-same">The Device ID should remain the same.</div>
              </ol>
              <ul>
                <li i18n="@@ipos-help.faq.once-newpkg-installled">Once the new package is installed, the device dashboard should display information based on the new package.</li>
                <li i18n="@@ipos-help.faq.device-reports-should-display">All the device reports should display information pertaining to the new package.</li>
              </ul>

            </div>
          </div>
      </div>
    </div>

    <!-- Section 11 -->
    <div class="card" #ODA id="ODACard">
      <div class="card-header" id="faqTen">
        <div class="card-header-content d-flex" id="ODACardHeaderContent">
          <div class="title" id="ODACardHeaderTitle" i18n="@@ipos-help.faq.title.oda">ODA</div>
          <div class="table_collapse_link collapsed " data-toggle="collapse" [attr.aria-expanded]="isOda"
            aria-controls="collapseOne" id="aboutODA">
            <img (click)="showDescription('aboutODA')" class="accordion_arrow chevron_down_dark table_row_expanded"
              alt="toggle section" [ngClass]="isOda?'transform-180':''" />
          </div>
        </div>
      </div>
      <div id="aboutODA" aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div"
        data-parent="#aboutODA" #collapse="ngbCollapse" [(ngbCollapse)]="!isOda">
        <div class="card-body" id="aboutODACardBody">
          <div class="content" id="aboutODACardContent">
            <span i18n="@@ipos-help.faq.question.how-to-log-into-oda"><strong>How do I log into the ODA?</strong></span>
            <p>
              <span i18n="@@ipos-help.faq.body.to-access-the-oda-tool-text">To access the On-Device Administration tool, click or tap
              three (3) times in the upper right-hand corner of IPOS. When
              prompted, enter the IPOS password on the login page.</span>
            </p>
            <!-- Preview image -->
            <img class="mb-3 help_faqs_twelve" alt="ODA login page" />
            <div i18n="@@ipos-help.faq.question.is-there-way-to-add-custom-program-text"><strong>Is there a way to add a custom application/program to run from IPOS?</strong></div>
            <p>
              <span i18n="@@ipos-help.faq.body.yes-oda-tool-has-option-text">Yes, the On-Device Administration tool provides an option to
              upload a custom application/program to run from IPOS in the
              <strong>Settings</strong> tab.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.faq.body.by-default-ipos-includes-text">By default, IPOS includes an
              <strong>Explore this PC</strong> button that allows the
              shoppers to exit the IPOS experience and go to the device’s
              desktop. As part of the <strong>Settings</strong> tab, you
              can control what this button does.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.faq.body.you-can-select-link-to-custom-program-text">You can select the
              <strong>Link to Custom Program</strong> option as a
              <strong>Button Functionality</strong> of
              <strong>Customizable Buttons</strong>. You can then choose
              and upload the desired application/program, and may also
              change the text of the button by simply modifying the
              <strong>Button Copy</strong>. It will appear in the bottom
              right corner of IPOS.</span>
            </p>
            <!-- Preview image -->
            <img class="help_faqs_thurteen" alt="ODA settings page to choose button copy" />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>